import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_cart_2: FaireProductEntity = {
  token: "atc_fs_cart_2",
  type: "product",
  name: "Ceramic Planter",
  brandName: "The Johnson Co",
  imageUrl:
    "https://www.figma.com/api/mcp/asset/9a741917-a623-4399-9fe8-06d9bc58a545",
  priceDollars: 4.0,
  msrpDollars: 8.0,
  description: "ATC migration seed product",
  tags: ["home", "decor"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
